"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = require("prop-types");

var _core = require("@emotion/core");

var _BaseMap = _interopRequireDefault(require("../BaseMap/BaseMap"));

var _MultiLayerMap = _interopRequireDefault(require("../MultiLayerMap/MultiLayerMap"));

var _CivicSandboxTooltip = _interopRequireDefault(require("../CivicSandboxMap/CivicSandboxTooltip"));

var _SandboxDrawer = _interopRequireDefault(require("./SandboxDrawer"));

var _SandboxIntroDialog = _interopRequireDefault(require("./SandboxIntroDialog"));

var _SandboxLegend = _interopRequireDefault(require("./SandboxLegend"));

require("./sandboxGeocoder.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          position: absolute;\n          top: 0;\n          right: 0;\n          padding: 0;\n          margin: 0;\n          width: 100%;\n          height: 100vh;\n          min-height: 650px;\n          @media (max-width: 850px) {\n            height: 100vh;\n            min-height: 600px;\n          }\n          @media (max-width: 500px) {\n            width: 100%;\n            height: 100vh;\n            min-height: 390px;\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var baseMapWrapper = (0, _core.css)("\n  height: 100vh;\n  min-height: 650px;\n  @media (max-width: 850px) {\n    height: 100vh;\n    min-height: 600px;\n  }\n  @media (max-width: 500px) {\n    padding-top: 40px;\n    width: 100%;\n    height: calc(100vh - 40px);\n    min-height: 390px;\n  }\n");

var Sandbox = function Sandbox(_ref) {
  var data = _ref.data,
      layerData = _ref.layerData,
      defaultFoundation = _ref.defaultFoundation,
      defaultSlides = _ref.defaultSlides,
      selectedPackage = _ref.selectedPackage,
      selectedPackageDescription = _ref.selectedPackageDescription,
      selectedFoundation = _ref.selectedFoundation,
      selectedSlide = _ref.selectedSlide,
      slideData = _ref.slideData,
      updatePackage = _ref.updatePackage,
      updateFoundation = _ref.updateFoundation,
      updateSlide = _ref.updateSlide,
      fetchSlideDataByDate = _ref.fetchSlideDataByDate,
      drawerVisible = _ref.drawerVisible,
      drawerVisualization = _ref.drawerVisualization,
      drawerLayerSelector = _ref.drawerLayerSelector,
      drawerExplore = _ref.drawerExplore,
      toggleDrawer = _ref.toggleDrawer,
      toggleDrawerLayerSelector = _ref.toggleDrawerLayerSelector,
      toggleDrawerVisualization = _ref.toggleDrawerVisualization,
      toggleDrawerExplore = _ref.toggleDrawerExplore,
      dialogVisible = _ref.dialogVisible,
      toggleDialog = _ref.toggleDialog,
      contributeDialogVisible = _ref.contributeDialogVisible,
      toggleContributeDialog = _ref.toggleContributeDialog,
      ContributeDialogComponent = _ref.ContributeDialogComponent,
      styles = _ref.styles,
      onFoundationClick = _ref.onFoundationClick,
      onSlideHover = _ref.onSlideHover,
      onBaseMapHover = _ref.onBaseMapHover,
      tooltipInfo = _ref.tooltipInfo,
      tooltipInfoVector = _ref.tooltipInfoVector,
      allSlides = _ref.allSlides,
      selectedFoundationDatum = _ref.selectedFoundationDatum,
      areSlidesLoading = _ref.areSlidesLoading,
      errors = _ref.errors,
      updateSlideKey = _ref.updateSlideKey;

  var _useState = (0, _react.useState)("light"),
      _useState2 = _slicedToArray(_useState, 2),
      baseMapStyle = _useState2[0],
      setBaseMapStyle = _useState2[1];

  var handleBaseMapStyleChange = function handleBaseMapStyleChange(baseMapStyleChangeEvent) {
    baseMapStyleChangeEvent.target.value === "light" ? setBaseMapStyle("light") : setBaseMapStyle("sandbox-dark");
  };

  var featuresArr = layerData.length ? layerData[0].data : [];
  var boundBox = layerData.length ? layerData[0].boundBox : [];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      highlightFeatureStateID = _useState4[0],
      setHighlightFeatureStateID = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      vectorSource = _useState6[0],
      setVectorSource = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      vectorSourceLayer = _useState8[0],
      setVectorSourceLayer = _useState8[1];

  var onHoverVectorLayer = function onHoverVectorLayer(info, mapboxRef) {
    var _info$features = _slicedToArray(info.features, 1),
        selectedFeature = _info$features[0];

    if (!selectedFeature) return;
    var selectedIndex = selectedFeature.layer && selectedFeature.layer.metadata && selectedFeature.layer.metadata["sandbox:index"];
    var hoverVectorSource = selectedFeature.source;
    var hoverVectorSourceLayer = selectedFeature.sourceLayer;
    var hasSource = mapboxRef.getSource(vectorSource);

    if (highlightFeatureStateID && hasSource) {
      mapboxRef.setFeatureState({
        source: vectorSource,
        sourceLayer: vectorSourceLayer,
        id: highlightFeatureStateID
      }, {
        highlight: false
      });
    }

    if (selectedIndex >= 0) {
      setVectorSource(hoverVectorSource);
      setVectorSourceLayer(hoverVectorSourceLayer);
      setHighlightFeatureStateID(selectedFeature.id);
      mapboxRef.setFeatureState({
        source: hoverVectorSource,
        sourceLayer: hoverVectorSourceLayer,
        id: selectedFeature.id
      }, {
        highlight: true
      });
    }

    var selectedProps = selectedFeature.properties;

    if (selectedProps && selectedIndex !== undefined) {
      var selectedDatum = {
        object: {
          properties: selectedProps
        },
        x: info.point[0],
        y: info.point[1]
      };
      onBaseMapHover(selectedDatum, selectedIndex);
    } else {
      var _selectedDatum = {};
      onBaseMapHover(_selectedDatum, selectedIndex);
    }
  };

  var mouseOutVectorLayer = function mouseOutVectorLayer(mapboxRef) {
    var hasSource = mapboxRef.getSource(vectorSource);

    if (hasSource) {
      mapboxRef.removeFeatureState({
        source: vectorSource,
        sourceLayer: vectorSourceLayer
      });
    }

    var selectedDatum = {
      object: {}
    };
    onBaseMapHover(selectedDatum);
  };

  return (0, _core.jsx)("div", {
    css: styles
  }, (0, _core.jsx)("div", {
    css: (0, _core.css)(_templateObject())
  }, (0, _core.jsx)(_SandboxIntroDialog["default"], {
    open: dialogVisible,
    onClose: toggleDialog
  }), (0, _core.jsx)(ContributeDialogComponent, {
    open: contributeDialogVisible,
    onClose: toggleContributeDialog
  }), (0, _core.jsx)(_SandboxDrawer["default"], {
    data: data,
    selectedSlide: selectedSlide,
    onChange: updateSlide,
    selectedPackage: selectedPackage,
    selectedPackageDescription: selectedPackageDescription,
    toggleDialog: toggleDialog,
    toggleContributeDialog: toggleContributeDialog,
    toggleDrawer: toggleDrawer,
    toggleLayerSelector: toggleDrawerLayerSelector,
    toggleVisualization: toggleDrawerVisualization,
    toggleExplore: toggleDrawerExplore,
    drawerVisible: drawerVisible,
    dialogVisible: dialogVisible,
    drawerVisualization: drawerVisualization,
    drawerLayerSelector: drawerLayerSelector,
    drawerExplore: drawerExplore,
    defaultSlides: defaultSlides,
    slideData: slideData,
    fetchSlideByDate: fetchSlideDataByDate,
    selectedFoundation: selectedFoundation,
    foundationData: layerData,
    defaultFoundation: defaultFoundation,
    allSlides: allSlides,
    updatePackage: updatePackage,
    updateFoundation: updateFoundation,
    foundationMapProps: layerData,
    onBaseMapStyleChange: handleBaseMapStyleChange,
    baseMapStyle: baseMapStyle,
    areSlidesLoading: areSlidesLoading,
    errors: errors,
    updateSlideKey: updateSlideKey,
    selectedFoundationDatum: selectedFoundationDatum
  })), (0, _core.jsx)("div", {
    css: baseMapWrapper
  }, (0, _core.jsx)(_BaseMap["default"], {
    civicMapStyle: baseMapStyle,
    initialLatitude: 39.810492,
    initialLongitude: -98.556061,
    initialZoom: 3.5,
    minZoom: 3,
    maxZoom: 14,
    useContainerHeight: true,
    updateViewport: false,
    boundBox: boundBox,
    bboxData: featuresArr,
    bboxPadding: 50,
    useScrollZoom: true,
    onBaseMapHover: onHoverVectorLayer,
    onBaseMapMouseOut: mouseOutVectorLayer,
    geocoder: true,
    geocoderOptions: {
      zoom: 13
    },
    geocoderPosition: "top-left"
  }, (0, _core.jsx)(_MultiLayerMap["default"], {
    mapLayers: layerData,
    onLayerClick: onFoundationClick,
    onHoverSlide: onSlideHover,
    selectedFoundationDatum: selectedFoundationDatum
  }, tooltipInfo && (0, _core.jsx)(_CivicSandboxTooltip["default"], {
    tooltipData: tooltipInfo
  }), tooltipInfoVector && (0, _core.jsx)(_CivicSandboxTooltip["default"], {
    tooltipData: tooltipInfoVector
  }))), (0, _core.jsx)(_SandboxLegend["default"], {
    foundationData: layerData,
    allSlides: allSlides,
    foundationMapProps: layerData,
    areSlidesLoading: areSlidesLoading,
    errors: errors
  })));
};

Sandbox.propTypes = {
  data: (0, _propTypes.shape)({
    packages: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
    slides: (0, _propTypes.shape)({})
  }).isRequired,
  layerData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired,
  defaultFoundation: (0, _propTypes.shape)({
    endpoint: _propTypes.string,
    name: _propTypes.string,
    visualization: _propTypes.string
  }),
  defaultSlides: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    endpoint: _propTypes.string,
    name: _propTypes.string,
    visualization: _propTypes.string
  })).isRequired,
  selectedPackage: _propTypes.string.isRequired,
  selectedPackageDescription: _propTypes.string.isRequired,
  selectedFoundation: _propTypes.string.isRequired,
  selectedSlide: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  slideData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired,
  updatePackage: _propTypes.func.isRequired,
  updateFoundation: _propTypes.func.isRequired,
  updateSlide: _propTypes.func.isRequired,
  fetchSlideDataByDate: _propTypes.func.isRequired,
  drawerVisible: _propTypes.bool.isRequired,
  drawerVisualization: _propTypes.bool.isRequired,
  drawerExplore: _propTypes.bool.isRequired,
  drawerLayerSelector: _propTypes.bool.isRequired,
  toggleDrawer: _propTypes.func.isRequired,
  toggleDrawerLayerSelector: _propTypes.func.isRequired,
  toggleDrawerVisualization: _propTypes.func.isRequired,
  toggleDrawerExplore: _propTypes.func.isRequired,
  dialogVisible: _propTypes.bool.isRequired,
  toggleDialog: _propTypes.func.isRequired,
  contributeDialogVisible: _propTypes.bool.isRequired,
  toggleContributeDialog: _propTypes.func.isRequired,
  ContributeDialogComponent: _propTypes.node.isRequired,
  styles: _propTypes.string,
  onFoundationClick: _propTypes.func,
  onSlideHover: _propTypes.func,
  onBaseMapHover: _propTypes.func,
  tooltipInfo: (0, _propTypes.shape)({
    content: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
    x: _propTypes.number,
    y: _propTypes.number
  }),
  tooltipInfoVector: (0, _propTypes.shape)({
    content: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
    x: _propTypes.number,
    y: _propTypes.number
  }),
  allSlides: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    checked: _propTypes.bool,
    color: (0, _propTypes.arrayOf)(_propTypes.number),
    endpoint: _propTypes.string,
    label: _propTypes.string,
    mapType: _propTypes.string,
    slideId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  })).isRequired,
  selectedFoundationDatum: (0, _propTypes.shape)({
    id: _propTypes.number,
    displayName: _propTypes.string,
    featureProperties: (0, _propTypes.shape)({}),
    colorKey: _propTypes.string,
    primaryFormat: _propTypes.string
  }),
  areSlidesLoading: _propTypes.bool,
  updateSlideKey: _propTypes.func,
  errors: _propTypes.bool
};
var _default = Sandbox;
exports["default"] = _default;